import { fetchWithAuth } from './api';

async function request(path, body, token) {
  const response = await fetch(`/api/auth${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body)
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Не удалось войти через Telegram');
  return data;
}

export const telegramLogin = (initData, createAccount = false, notificationsEnabled = false) => request('/telegram', {
  initData, create_account: createAccount, ...(createAccount ? { notifications_enabled: notificationsEnabled === true } : {})
});

const registrationPermissions = new WeakMap();
export async function registerTelegramAccount(app) {
  // Reuse the choice if registration needs a network retry in this Mini App launch.
  let permission = registrationPermissions.get(app);
  if (!permission) {
    permission = (async () => {
      try {
        const user = JSON.parse(new URLSearchParams(app.initData).get('user') || '{}');
        if (user?.allows_write_to_pm === true) return true;
        return await requestTelegramWriteAccess(app);
      } catch { return false; } // Unsupported clients can still create a profile.
    })();
    registrationPermissions.set(app, permission);
  }
  return telegramLogin(app.initData, true, await permission);
}
export const previewTelegramConnection = (initData, code) => request('/telegram/account/preview', { initData, code });
export const redeemTelegramConnection = (initData, code) => request('/telegram/account/redeem', { initData, code });
export const getTelegramAccount = () => fetchWithAuth('/auth/telegram/account');
export const createTelegramConnection = () => fetchWithAuth('/auth/telegram/account/connection', { method: 'POST', body: '{}' });
export const addTelegramCredentials = (email, password, initData) => fetchWithAuth('/auth/telegram/account/credentials', { method: 'POST', body: JSON.stringify({ email, password, initData }) });
export const resendTelegramVerification = () => fetchWithAuth('/auth/telegram/account/resend-verification', { method: 'POST', body: '{}' });

export const getTelegramNotificationSettings = (signal) => fetchWithAuth('/auth/telegram/notifications', { signal });
export const setTelegramNotifications = (enabled) => fetchWithAuth('/auth/telegram/notifications', { method: 'PUT', body: JSON.stringify({ enabled }) });
export const testTelegramNotification = () => fetchWithAuth('/auth/telegram/notifications/test', { method: 'POST', body: '{}' });

export function requestTelegramWriteAccess(app) {
  return new Promise((resolve, reject) => {
    if (!app?.isVersionAtLeast?.('6.9') || typeof app.requestWriteAccess !== 'function') {
      reject(new Error('TELEGRAM_UPDATE_REQUIRED')); return;
    }
    app.requestWriteAccess(granted => resolve(granted === true));
  });
}

export async function linkTelegramAccount(initData, credentials) {
  // Do not store the temporary Polka token until linking succeeds.
  const session = await request('/login', credentials);
  return request('/telegram/link', { initData }, session.token);
}
